/**
 * Parse a backend timestamp. The API emits UTC ISO-8601 with an explicit
 * offset ("2026-07-29T13:29:45+00:00"); the retired naive 'Y-m-d H:i' format
 * carried no offset but was always UTC, so pin it with a 'Z' rather than let
 * the browser read it as local.
 */
function parseApiDate(val) {
  if (!val) return null;
  const raw = String(val).trim();
  if (!raw) return null;
  const d = raw.includes('T') ? new Date(raw) : new Date(`${raw.replace(' ', 'T')}Z`);
  return isNaN(d.getTime()) ? null : d;
}

// Fixed: dateFormat (was dateFormate — typo)
export function dateFormat(val) {
  const d = parseApiDate(val);
  if (!d) return '—';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Date + time in the VIEWER's timezone. Use this anywhere a bare timestamp
 * would otherwise be rendered into JSX — the raw ISO string is unreadable and
 * stays in UTC.
 */
export function dateTimeFormat(val) {
  const d = parseApiDate(val);
  return d ? d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '—';
}

export function formatSize(bytes) {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let n = parseInt(bytes, 10) || 0;
  let l = 0;
  while (n >= 1024 && ++l) n /= 1024;
  return `${n.toFixed(n < 10 && l > 0 ? 1 : 0)} ${units[l]}`;
}

export function formatDuration(totalSeconds) {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
}

export function useDocumentTitle(title) {
  // Used as a plain call — sets document.title once on mount.
  // Call inside useEffect in consuming component if reactive title is needed.
  document.title = `PopupPush Admin — ${title}`;
}

export function exportToCSV(filename, rows, headers) {
  const escape = v => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const lines = [
    headers.map(h => escape(h.label)).join(','),
    ...rows.map(row => headers.map(h => escape(row[h.key])).join(',')),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export function onDragEnd(result, columns, setColumns) {
  if (!result.destination) return;
  const { source, destination } = result;
  if (source.droppableId !== destination.droppableId) {
    const srcCol  = columns[source.droppableId];
    const dstCol  = columns[destination.droppableId];
    const srcItems = [...srcCol.items];
    const dstItems = [...dstCol.items];
    const [removed] = srcItems.splice(source.index, 1);
    dstItems.splice(destination.index, 0, removed);
    setColumns({ ...columns, [source.droppableId]: { ...srcCol, items: srcItems }, [destination.droppableId]: { ...dstCol, items: dstItems } });
  } else {
    const col   = columns[source.droppableId];
    const items = [...col.items];
    const [removed] = items.splice(source.index, 1);
    items.splice(destination.index, 0, removed);
    setColumns({ ...columns, [source.droppableId]: { ...col, items } });
  }
}
